import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { FieldErrors, UseFormSetValue } from "react-hook-form";

import { AutoCompleteItem, Dropdown } from "@/components/Dropdown/Dropdown";

import { CreateLiPost } from "../schema/liPost";
import { getTimeFrameOptions } from "../constants/createLiPost.constants";

interface TimeFrameFieldProps {
	formValues: Partial<CreateLiPost>;
	setValue: UseFormSetValue<CreateLiPost>;
	errors: FieldErrors<CreateLiPost>;
}

/** Time-frame dropdown shown for every source type except a single post URL. */
export const TimeFrameField: FunctionComponent<TimeFrameFieldProps> = ({
	formValues,
	setValue,
	errors,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`liPost.${key}`);

	return (
		<div className="flex flex-row w-full mb-7">
			<Dropdown
				data={getTimeFrameOptions(formValues.type)}
				defaultValue={
					formValues.timeFrame
						? { id: formValues.timeFrame, title: `last ${formValues.timeFrame} days` }
						: undefined
				}
				error={!!errors.timeFrame?.message}
				floating={true}
				handleSelect={(value: AutoCompleteItem) => {
					setValue("timeFrame", Number(value.id), { shouldDirty: true, shouldValidate: true });
				}}
				label={ts("timeFrame")}
				portal
			/>
		</div>
	);
};
